import get from 'lodash/get'

export const hasDependencies = shopper => !!['lands'].find(dependency => get(shopper, `${dependency}.length`, 0) > 0)
